import {Container} from "./styles";
import ScrollAnimation from "react-animate-on-scroll";
import FE from "../../assets/regular_icons/Front.png";
import BE from "../../assets/regular_icons/Backend.png";
import ui_ux from "../../assets/regular_icons/UI-UX.png";
import software from "../../assets/regular_icons/software.png";
import techStackIcons from "../../assets/lang_icons";
import {Timeline} from "../Timeline/Timeline";

const skills: string[] = [
    "React", "Angular", "Redux", "NextJS", "MaterialUI", "AntD", "Tailwind", "Axios", "Micro-Frontend", "Typescript", "Javascript", "PWA", "Electron", "React Query", "Tailwind", "Recharts", "React Spring","React Router", "Chart JS", "Web Socket", "Firebase", "Git & Github", "Jira", "Postman", "Docker", "Figma"
];

const skillIcons = [
    {src: techStackIcons.reactIcon, alt: "React"},
    {src: techStackIcons.nodeIcon, alt: "Node"},
    {src: techStackIcons.jsIcon, alt: "JavaScript"},
    {src: techStackIcons.typescriptIcon, alt: "Typescript"},
    {src: techStackIcons.angular, alt: "Angular"},
    {src: techStackIcons.htmlIcon, alt: "HTML"},
    {src: techStackIcons.cssIcon, alt: "CSS"},
    {src: techStackIcons.sassIcon, alt: "Sass"},
    {src: techStackIcons.bootstrapIcon, alt: "Bootstrap"},
    {src: techStackIcons.mongo, alt: "MongoDB"},
    // {src: index.express, alt: "ExpressJS"},
    {src: techStackIcons.pwa, alt: "PWA"},
    {src: techStackIcons.electron, alt: "Electron"}
];

const techCategories = [
    {img: FE, title: "Frontend Development"},
    {img: BE, title: "Backend Development"},
    {img: ui_ux, title: "UI/UX Designing"},
    {img: software, title: "Software Prototype"}
];


export function Skills() {
    return (
        <Container id="skills">
            <div className="w-full">
                <ScrollAnimation animateIn="fadeInLeft">
                    <h2>What I work with</h2>
                    <div className="flex flex-wrap gap-3 text-left my-10">
                        {skills.map((skill, index) => (
                            <div
                                key={index}
                                className="flex items-center justify-center px-3 py-1 text-neutral-400 rounded-full shadow-md border font-bold hover:bg-neutral-500 hover:text-white duration-300"
                            >
                                {skill}
                            </div>
                        ))}
                    </div>

                    <div className="hard-skills grid grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
                        {skillIcons.map(({src, alt}, index) => (
                            <div key={index} className="hability">
                                <img loading="lazy" src={src} alt={alt} className="w-12 h-12"/>
                            </div>
                        ))}
                    </div>
                </ScrollAnimation>
                <Timeline/>
            </div>
            {/*<div className="flex flex-wrap justify-center gap-6 text-[var(--blue)] p-10">*/}
            {/*    {techCategories.map(({img, title}, index) => (*/}
            {/*        <ScrollAnimation key={index} animateIn="fadeInLeft" delay={index * 100 + 400}>*/}
            {/*            <div className="shadow-card rounded-3xl bg-[#2b2b2b] p-8 text-center w-[260px]">*/}
            {/*                <img className="m-auto p-5 w-20 h-20" src={img} alt={title}/>*/}
            {/*                <p>{title}</p>*/}
            {/*            </div>*/}
            {/*        </ScrollAnimation>*/}
            {/*    ))}*/}
            {/*</div>*/}
        </Container>

    );
}
